import AreaContainer from "../AreaContainer";
import styles from './updateinfo.module.css';
import globalStyles from '../result.module.css';
interface Props {
  modified: string;
  type: string;
}

const UpdatedInfo = ({ modified, type }: Props) => {
  return (
    <AreaContainer area="property-updated" style={null} extraClass={null}>
      <div className={styles.UpdatedWrapper}>
        <p className={`${globalStyles.mediumText} ${globalStyles.lightColorText}`}>
          This {type} was last updated on {new Date(modified.replace(" ", "T")).toLocaleDateString("en-GB")}
        </p>
      </div>
    </AreaContainer>
  );
};

export default UpdatedInfo;
